import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const SHORTCUTS: { keys: string; label: string }[] = [
  { keys: '⌘+B', label: 'Bold' },
  { keys: '⌘+I', label: 'Italic' },
  { keys: '⌘+U', label: 'Underline' },
  { keys: '⌘+Shift+X', label: 'Strikethrough' },
  { keys: '⌘+K', label: 'Insert link' },
  { keys: '/', label: 'Open command menu' },
  { keys: '⌘+S', label: 'Force save' },
  { keys: '⌘+Enter', label: 'Submit' },
  { keys: '⌘+.', label: 'Toggle focus mode' },
  { keys: '?', label: 'Show this overlay' },
  { keys: 'Esc', label: 'Close menu / overlay / dialog' },
];

export function ShortcutHintOverlay({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
          <DialogDescription>
            Speed up clinical writing — these bindings work anywhere in the editor.
          </DialogDescription>
        </DialogHeader>
        <dl className="grid grid-cols-[max-content_1fr] gap-x-6 gap-y-2 text-sm">
          {SHORTCUTS.map((s) => (
            <div key={s.keys} className="contents">
              <dt className="font-mono text-neutral-600">{s.keys}</dt>
              <dd className="text-accent-ink">{s.label}</dd>
            </div>
          ))}
        </dl>
      </DialogContent>
    </Dialog>
  );
}
